import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-p-2 child-content" }
const _hoisted_2 = {
  key: 0,
  class: "mdi mdi-lock-outline",
  style: {"fontSize":"1rem"}
}
const _hoisted_3 = { class: "p-fluid p-formgrid p-grid p-input-filled" }
const _hoisted_4 = { class: "p-field p-col-12" }
const _hoisted_5 = { for: "reasonName" }
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = { class: "p-field p-col-12" }
const _hoisted_8 = { for: "reasonDescription" }
const _hoisted_9 = { class: "p-field-checkbox p-col-12" }
const _hoisted_10 = { for: "reasonTextfield" }
const _hoisted_11 = { class: "p-field-checkbox p-col-12" }
const _hoisted_12 = { for: "reasonActive" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_DexInputText = _resolveComponent("DexInputText")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_DataTable, {
        value: _ctx.deleteReasons,
        loading: _ctx.loading,
        class: "p-datatable-sm",
        autoLayout: true,
        columnResizeMode: "fit",
        scrollable: true,
        scrollHeight: "flex",
        rowHover: true,
        onRowDblclick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openEditDialog($event.data))),
        onRowReorder: _ctx.onRowReorder
      }, {
        loading: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.Loading')), 1)
        ]),
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('Squeeze.General.NoEntriesFound', { entryName: _ctx.$t('Squeeze.DocumentClasses.DeleteReasons') })), 1)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.$t('Squeeze.General.NewEntry'),
            type: "button",
            icon: "mdi mdi-plus",
            class: "p-button",
            onClick: _ctx.openNewDialog
          }, null, 8, ["label", "onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            rowReorder: true,
            style: {"min-width":"2rem","max-width":"2rem"}
          }),
          _createVNode(_component_Column, {
            field: "name",
            header: _ctx.$t('Squeeze.General.Name'),
            style: {"min-width":"12rem"}
          }, null, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "translatedDescription",
            header: _ctx.$t('Squeeze.DocumentClasses.Description'),
            style: {"min-width":"16rem"}
          }, {
            body: _withCtx((slotProps) => [
              (slotProps.data.translatedDescriptionSource === 'default')
                ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_2, null, 512)), [
                    [_directive_tooltip, _ctx.$t('Squeeze.System.BuiltInValue')]
                  ])
                : (slotProps.data.translatedDescriptionSource === 'sqz' || slotProps.data.translatedDescriptionSource === 'auto')
                  ? _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                      key: 1,
                      class: "translation-link",
                      to: { name: 'DocumentClassTranslationsSubView', params: { documentClassId: _ctx.documentClassId }, query: { focusKey: _ctx.getReasonTranslationKey(slotProps.data.name) } }
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("i", {
                          class: "mdi mdi-file-replace-outline",
                          style: {"fontSize":"1rem"}
                        }, null, -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])), [
                      [_directive_tooltip, _ctx.$t('Squeeze.System.Translations')]
                    ])
                  : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(slotProps.data.translatedDescription), 1)
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "textfield",
            header: _ctx.$t('Squeeze.DocumentClasses.CommentField'),
            style: {"min-width":"10rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: slotProps.data.textfield,
                binary: true,
                "onUpdate:modelValue": ($event: any) => (_ctx.onToggleTextfield(slotProps.data, $event))
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, {
            field: "active",
            header: _ctx.$t('Squeeze.DocumentClasses.Active'),
            style: {"min-width":"8rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createVNode(_component_Checkbox, {
                modelValue: slotProps.data.active,
                binary: true,
                "onUpdate:modelValue": ($event: any) => (_ctx.onToggleActive(slotProps.data, $event))
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }, 8, ["header"]),
          _createVNode(_component_Column, { style: {"min-width":"7rem","max-width":"7rem","text-align":"right"} }, {
            body: _withCtx((slotProps) => [
              _withDirectives(_createVNode(_component_Button, {
                icon: "mdi mdi-pencil-outline",
                class: "p-button-lg p-button-rounded p-button-success p-button-text",
                onClick: ($event: any) => (_ctx.openEditDialog(slotProps.data))
              }, null, 8, ["onClick"]), [
                [
                  _directive_tooltip,
                  _ctx.$t('Squeeze.Locators.Edit'),
                  void 0,
                  { bottom: true }
                ]
              ]),
              (!slotProps.data.systemDefault)
                ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "mdi mdi-delete-outline",
                    class: "p-button-lg p-button-rounded p-button-danger p-button-text",
                    onClick: ($event: any) => (_ctx.openDeleteDialog(slotProps.data))
                  }, null, 8, ["onClick"])), [
                    [
                      _directive_tooltip,
                      _ctx.$t('Squeeze.Validation.Buttons.Delete'),
                      void 0,
                      { bottom: true }
                    ]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value", "loading", "onRowReorder"])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteReason
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _ctx.closeEntryDialog,
      onOnConfirm: _ctx.saveReason,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText,
      showKeepDialogOpen: !_ctx.isEditMode
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('Squeeze.General.Name')) + " *", 1),
                _createVNode(_component_InputText, {
                  id: "reasonName",
                  modelValue: _ctx.entry.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.entry.name) = $event)),
                  disabled: _ctx.disableNameEdit,
                  class: _normalizeClass({'p-invalid': _ctx.isEntryInvalid() && _ctx.showValidationMessage})
                }, null, 8, ["modelValue", "disabled", "class"]),
                (_ctx.isEntryInvalid() && _ctx.showValidationMessage)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_ctx.$t('Forms.Val.CharactersWithoutSpecialCharacters', { field: _ctx.$t('Squeeze.General.Name')})), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Description')), 1),
                _createVNode(_component_DexInputText, {
                  id: "reasonDescription",
                  modelValue: _ctx.entry.description,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.entry.description) = $event)),
                  modelModifiers: { trim: true },
                  translatedDescription: _ctx.descriptionLockValue,
                  disableTranslationUrl: _ctx.descriptionDisableUrl,
                  translationKey: _ctx.descriptionTranslationKey
                }, null, 8, ["modelValue", "translatedDescription", "disableTranslationUrl", "translationKey"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Checkbox, {
                  id: "reasonTextfield",
                  modelValue: _ctx.entry.textfield,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.entry.textfield) = $event)),
                  binary: true
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.CommentField')), 1)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Checkbox, {
                  id: "reasonActive",
                  modelValue: _ctx.entry.active,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.entry.active) = $event)),
                  binary: true
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('Squeeze.DocumentClasses.Active')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnClose", "onOnConfirm", "loading", "headerText", "showKeepDialogOpen"])
  ], 64))
}